/**
 * Created by Bart Decorte
 * Date: 05/12/2018
 * Time: 16:03
 */
import IndexPage from '../IndexPage';

class LogsIndex extends IndexPage {
  constructor() {
    super();
    this.bindKeys(this.keyBindings());
  }
}

export default LogsIndex;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Logs/LogsIndex.js